import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SubscribeEmailComponent = (props: any) => {
  const { email, setEmail, subscribedEmail } = props;

  return (
    <main className="deny-email">
      <div className="con">
        <h2>
          {getLanguageValue(PAGE_TYPE.COMMON, "subscribeEmail.txtContent")}
        </h2>

        <div className="form">
          <div className="input-box">
            <input
              type="text"
              placeholder={getLanguageValue(
                PAGE_TYPE.COMMON,
                "subscribeEmail.emailPlaceholder"
              )}
              value={email}
              onChange={(evt) => setEmail(evt.target.value)}
            />
          </div>
        </div>

        <div className="btn">
          <div>
            <button onClick={subscribedEmail}>
              {getLanguageValue(
                PAGE_TYPE.COMMON,
                "subscribeEmail.btnRequestUnSubscribe"
              )}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};
export default SubscribeEmailComponent;
